import { render, staticRenderFns } from "./search.vue?vue&type=template&id=49fb0899&scoped=true&lang=pug"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"
import style0 from "./search.vue?vue&type=style&index=0&id=49fb0899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb0899",
  null
  
)

export default component.exports